export default __webpack_public_path__ + "static/media/logo.0cc11ed5.svg";